<template>
  <div>
    <div class="animated fadeIn">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      />
    </div>
    <b-card>
      <b-row>
        <b-col xl="6" md="6" sm="12">
          <span class="f-g">
            <h3 v-if="!haveItems">Você não possui sorteios ativos</h3>
            <h3 v-if="haveItems">
              Você possui {{ numSorteios }} sorteios ativos
            </h3>
          </span>
        </b-col>
        <b-col xl="6" md="6" sm="12">
          <div>
            <b-button
              variant="success"
              class="my-2 my-sm-0 mr-sm-2 w100"
              type="submit"
              v-b-modal.modalAddSorteio
              @click="inserirSorteio"
            >
              <i class="fa fa-plus fa-xl"></i>
              Adicionar sorteio
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-card class="text-center f-g" v-if="!haveItems">
      <i class="fa fa-frown-o fa-custom-size"></i>
      <h4>Desculpe, não encontramos nenhum sorteio :(</h4>
      <h5>Para iniciar, clique no botão acima e comece as integrações!</h5>
    </b-card>
    <b-card class="text-center mt-3" v-if="haveItems">
      <b-table
        :items="items"
        :fields="fields"
        striped
        bordered
        hover
        @row-clicked="rowHandler"
      >
        <template v-slot:cell(urlthumbnail)="data">
          <img
            v-if="data.item.urlthumbnail"
            :src="data.item.urlthumbnail"
            alt="Thumbnail"
            style="height: 32px"
          />
          <span v-else>Sem imagem</span>
        </template>
        <template v-slot:cell(isdestaque)="data">
          <i v-if="data.item.isdestaque == 1" class="fa fa-star fa-lg"></i>
          <i v-else class="fa fa-star-o fa-lg"></i>
        </template>
      </b-table>
    </b-card>
    <b-modal
      ref="modalEditaSorteio"
      size="lg"
      centered
      hide-footer
      :title="titleSorteioModal"
    >
      <b-row>
        <b-col cols="4" @click="editarImagem(urlImagemSelecionado)">
          <b-col cols="12" class="centerModal">
            <i class="fa fa-file-image-o fa-custom-size" aria-hidden="true"></i>
            <span v-if="!urlImagemSelecionado">
              Vincular
              <br />Imagem
            </span>
            <span v-if="urlImagemSelecionado">
              Editar
              <br />Imagem
            </span>
          </b-col>
        </b-col>

        <b-col cols="4" @click="editarSorteio(idSorteioSelecionado)">
          <b-col cols="12" class="centerModal">
            <i class="fa fa-edit fa-custom-size" aria-hidden="true"></i>
            <span>
              Editar
              <br />sorteio
            </span>
          </b-col>
        </b-col>

        <b-col cols="4" @click="desvincularSorteio(idSorteioSelecionado)">
          <b-col cols="12" class="centerModal">
            <i class="fa fa-times fa-custom-size" aria-hidden="true"></i>
            <span>
              Desvincular
              <br />sorteio
            </span>
          </b-col>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import axios from "axios";
import * as config from "@/config.json";

export default {
  name: "sorteios",
  components: {
    Loading,
  },
  data: function () {
    return {
      isLoading: false,
      temSorteios: false,
      numSorteios: 0,
      items: [],
      fields: [
        { key: "urlthumbnail", label: "Imagem" },
        { key: "titulo", label: "Sorteio" },
        { key: "descricao", label: "Descrição" },
        { key: "data_inicial", label: "Início" },
        { key: "data_final", label: "Fim" },
      ],
      haveItems: false,
      titleSorteioModal: "",
      idSorteioSelecionado: "",
      urlImagemSelecionado: "",
    };
  },
  methods: {
    inserirSorteio() {
      this.$router.push("sorteios/inserir-sorteio");
    },
    limpaLocalStorage() {
      localStorage.removeItem("image");
      localStorage.removeItem("selecionado");
      localStorage.removeItem("titulo");
      localStorage.removeItem("descricao");
      localStorage.removeItem("data_inicial");
      localStorage.removeItem("data_final");
      localStorage.removeItem("have-push");
      localStorage.removeItem("titulo_sorteio");
      localStorage.removeItem("id_sorteio");
      localStorage.removeItem("url_imagem");
    },
    atualizarJornalzinho() {
      this.$router.push("sorteios/atualizar-jornalzinho");
    },
    rowHandler(record) {
      this.titleSorteioModal = `Sorteio: ${record.titulo}`;
      this.idSorteioSelecionado = record.id;
      this.urlImagemSelecionado = record.urlimagem;
      if (record.isdestaque == 1) {
        this.sorteioDestacado = true;
      } else {
        this.sorteioDestacado = false;
      }
      this.$refs.modalEditaSorteio.show();
    },
    editarImagem(url) {
      localStorage.setItem("url_imagem", url);
      localStorage.setItem("titulo_sorteio", this.titleSorteioModal);
      localStorage.setItem("id_sorteio", this.idSorteioSelecionado);
      this.$router.push({ path: "sorteios/editar-imagem" });
    },
    editarSorteio() {
      this.$router.push({
        path: `sorteios/editar-sorteio/${this.idSorteioSelecionado}`,
      });
    },

    async realizaDesvinculoSorteio(idSorteio) {
      const url = `${config.default.servidor}/gerencial/sorteio/${idSorteio}`;

      try {
        const response = await axios({
          url,
          method: "delete",
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          await this.$alert("Sorteio desvinculado!", "Sucesso", "success");
          this.procurarSorteios();
        }
      } catch (error) {
        console.log({ error });
      }
    },

    async desvincularSorteio(id) {
      this.$refs.modalEditaSorteio.hide();

      const res = await this.$swal({
        title: "Sorteio",
        text: "Confirma desvincular este sorteio do app?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      });

      if (res.value) {
        await this.realizaDesvinculoSorteio(id);
      }
    },

    async procurarSorteios() {
      this.isLoading = true;

      const url = `${
        config.default.servidor
      }/gerencial/sorteio/ativo/${localStorage
        .getItem("enterprise_id")
        .toString()}`;
      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          if (response.data.data.length != 0) {
            this.items = response.data.data;
            this.numSorteios = this.items.length;
            this.haveItems = true;
          } else {
            this.haveItems = false;
          }
          this.isLoading = false;
        }
      } catch (error) {
        console.log({ error });
      }
    },
  },

  beforeMount() {
    this.limpaLocalStorage();
    this.procurarSorteios();
  },
};
</script>
